import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Sidebar from "../../components/Sidebar";
import { RiEyeLine } from "react-icons/ri";
import { GoDotFill } from "react-icons/go";
import { BASE_URL, GET_CONSULTATION_LISTING } from "../../API";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/Loader";

function DiagnosticSuggestions() {
  const token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);
  const [pendingConsultation, setPendingConsultation] = useState([]);
  const [approvedConsultation, setApprovedConsultation] = useState([]);
  const [allConsultations, setAllConsultation] = useState([]);

  useEffect(() => { getConsultation() }, []);

  const getConsultation = async () => {
    setIsLoading(true);
    const headers = {
      token: token,
    };
    try {
      const response = await axios.get(BASE_URL + GET_CONSULTATION_LISTING, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        const data = json.data
        setAllConsultation(data.allConsultations)
        setPendingConsultation(data.pendingConsultation);
        setApprovedConsultation(data.approvedConsultation);
      }
    }
    catch (err) { console.error("Best season product fetch error:", err) }
    finally { setIsLoading(false) }
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex">
                <div>
                  <h6 className="comm_page_heading">Diagnostic Suggestions</h6>
                  <p className="comm_page_sub_heading">
                    Receive AI-driven diagnostic suggestions based on consultation
                    data, helping guide accurate and timely treatment decisions
                  </p>
                </div>
                <div className="d-flex sort_by_filter_outer">
                  <div className="head">Sort By:</div>
                  <div className="dropdown_inner_list_select">
                    <Form.Select>
                      <option value="1">Date </option>
                      <option value="2">Patient Name</option>
                      <option value="3">Condition</option>
                    </Form.Select>
                  </div>
                </div>
              </div>
              <div className="comm-table pt-0">
                <Table>
                  <thead>
                    <tr className="head-class-td">
                      <th>Sr. no.</th>
                      <th>Patient ID</th>
                      <th>Patient’s Name</th>
                      <th>Date of Consultation</th>
                      <th>Diagnosis</th>
                      <th>Status</th>
                      <th width="10%">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allConsultations && allConsultations.length > 0 ?
                      allConsultations.map((data, id) => {
                        const status = data?.is_approved
                        return (
                          <tr>
                            <td>{id + 1}</td>
                            <td className="id_txt">{`#${data?.user_id?.patient_id}`}</td>
                            <td>{data?.user_id?.full_name}</td>
                            <td>
                              {data.createdAt
                                ? moment(Number(data.createdAt)).format("DD-MM-YYYY")
                                : "Not available"}
                            </td>
                            <td> {data?.condition || 'Not Specified'} </td>
                            <td>
                              {status ?
                                <div className="pending-status completed">
                                  <GoDotFill />
                                  completed
                                </div>
                                :
                                <div className="pending-status">
                                  <GoDotFill />
                                  Pending
                                </div>
                              }

                            </td>
                            <td>
                              <Link className="table-view-btn" to="/diagnostic-suggestions-view" state={{ consultData: data }}>
                                <RiEyeLine />
                              </Link>
                            </td>
                          </tr>
                        )
                      })
                      :
                      <h2>No Cosultation Found!!</h2>
                    }
                  </tbody>
                </Table>
              </div>``
              <div className="d-flex table_bottom_row">
                <h4 className="page_count_txt">1-8 of 50 items</h4>
                <div className="d-flex btn_grp">
                  <button className="table_bott_btn">Previous</button>
                  <button className="table_bott_btn">Next</button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default DiagnosticSuggestions;
